// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GBvU","col":"styles_col__1QEo2"};